// extracted by mini-css-extract-plugin
export default {"form__control":"Input_form__control__XVNNl"};